import { CardFooterItem } from "$components/card";
import { FormattedDate } from "$components/date/formatted-date";
import { FormattedMessage } from "react-intl";

type Props = {
  issuedBy?: string;
  issuedAt: string;
};

const PaperPrescriptionFooterItems: FC<Props> = ({ issuedBy, issuedAt }) => (
  <>
    <CardFooterItem
      label={
        <FormattedMessage
          id="patient.history.prescription.paperPrescription.issuedOn"
          defaultMessage="Paper prescription issued:"
        />
      }
    >
      <FormattedDate value={issuedAt} />
    </CardFooterItem>
    {issuedBy && (
      <CardFooterItem
        label={
          <FormattedMessage
            id="patient.history.prescription.paperPrescription.issuedBy"
            defaultMessage="By:"
          />
        }
      >
        {issuedBy}
      </CardFooterItem>
    )}
  </>
);

export { PaperPrescriptionFooterItems };
